import React from 'react';
import { NavigatorContextConsumer } from '../navigator/navigator-context.jsx';

const navigationUtilities = WrappedComponent => {
  return (props) => {
    return (
      <NavigatorContextConsumer>
        {properties => <WrappedComponent focusTo={properties.focusTo} navigateByDirection={properties.navigateByDirection} pauseSpatialNavigation={properties.pauseSpatialNavigation} resumeSpatialNavigation={properties.resumeSpatialNavigation} {...props} />}
      </NavigatorContextConsumer>
    );
  }
}

export { navigationUtilities };